var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.getTextModel)?[_c('el-input-number',_vm._b({attrs:{"precision":_vm.item.precision || 6,"controls-position":_vm.item['controls-position'] || ''},on:{"change":function (val) {
          _vm.item.change && _vm.item.change(val, _vm.item);
        }},model:{value:(_vm.form[_vm.item.bind]),callback:function ($$v) {_vm.$set(_vm.form, _vm.item.bind, _vm._n($$v))},expression:"form[item.bind]"}},'el-input-number',_vm.item,false))]:_c('div',[_vm._v("\n    "+_vm._s(_vm.form[_vm.item.bind])+"\n  ")])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f013738","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./packages/SrAdd/components/form-item-input-number.vue
// module id = 117
// module chunks = 0